import React from "react";
import { styled } from "@mui/system";
import ReferAFriendTrustIcon from "../ReferAFriendTrustIcon";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  padding: "8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "20px",
  background: "#F5F3EF",
}));

const ReferAFriendIcon = () => {
  return (
    <Wrapper>
      <ReferAFriendTrustIcon />
    </Wrapper>
  );
};

export default ReferAFriendIcon;
